"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import { Component, Vue } from "vue-property-decorator";
import UiGrid, { GridController } from "@/components/grid/UiGrid.vue";
import API from "@ym-framework/api-utils";
import { APIDataSource } from "@/components/grid/data-source";
import QuestionSlot from "@/components/QuestionSlot.vue";
const emptyImage = require("@/assets/img/safety-empty/security-list-null.png");
import { Debounce } from "vue-debounce-decorator";
const kefu_new = require("@/assets/appImg/kefu_new.png");
let EarlyWarningSettings = class extends Vue {
  constructor() {
    super(...arguments);
    this.searchName = "";
    this.selectedItems = [];
    this.bindWechatStatus = false;
    this.previewDialogVisible = false;
    this.previewImageUrl = "";
    this.tipDialogVisible = false;
    this.errorPermissionName = "";
    this.kefuImg = kefu_new;
    this.gridController = new GridController(
      new APIDataSource("api://base.auth/api/v1/monitor/alarm/internal-events")
    );
    this.empty_image = emptyImage;
  }
  mounted() {
    return __async(this, null, function* () {
      this.getAccountInfo();
      yield this.gridController.search();
    });
  }
  selectItems(selected) {
    this.selectedItems = [];
    for (const item of selected) {
      this.selectedItems.push(item);
    }
  }
  changeEarlyWarningSettingStatus(row) {
    return __async(this, null, function* () {
      try {
        let arr = [];
        arr.push(row.eventId);
        if (row.status) {
          yield API.put(`api://base.auth/api/v1/monitor/alarm/internal-events/batch-open`, {
            ids: arr
          });
          this.$message.success(this.$t("early_warning_settings.change_status_success"));
        } else {
          yield API.put(`api://base.auth/api/v1/monitor/alarm/internal-events/batch-close`, {
            ids: arr
          });
          this.$message.success(this.$t("early_warning_settings.change_status_close_success"));
        }
      } catch (error) {
        if (error.hasOwnProperty("response")) {
          if (error.response.data.errors.datas[0].code === "monitorEventSettings.event.not.impl.error") {
            this.errorPermissionName = row.eventName;
            this.tipDialogVisible = true;
          } else {
            this.$message.error(error.response.data.errors.datas[0].message);
          }
        }
        row.status = !row.status;
      }
    });
  }
  addEarlyWarningSetting() {
    this.$router.push("/config_early_warning");
  }
  bindWechat() {
    return __async(this, null, function* () {
      this.$router.push("/account_management");
    });
  }
  getAccountInfo() {
    return __async(this, null, function* () {
      try {
        const response = yield API.get(
          "api://base.auth/api/v8/accounts"
        );
        if (response.data.nick_name) {
          this.bindWechatStatus = true;
        } else {
          this.bindWechatStatus = false;
        }
      } catch (error) {
      }
    });
  }
  searchByName(name) {
    return __async(this, null, function* () {
      try {
      } catch (error) {
        if (error.hasOwnProperty("response")) {
          this.$message.error(error.response.data.errors.datas[0].message);
        }
      }
    });
  }
  shopPreview(url) {
    if (url) {
      this.previewImageUrl = url;
      this.previewDialogVisible = true;
    } else {
      this.$message.warning(this.$t("early_warning_settings.no_preview_url"));
    }
  }
  closePreviewDialog() {
    this.previewDialogVisible = false;
    this.previewImageUrl = "";
  }
  getNoticeMembersText(members) {
    const memberMap = {
      "MANAGER": this.$t("config_early_warning.form.notice_members_2"),
      "MAIN_ACCOUNT": this.$t("config_early_warning.form.notice_members_1")
    };
    return members.map((member) => memberMap[member] || member).join("\u3001");
  }
  editEarlyWarningSetting(row) {
    return __async(this, null, function* () {
      console.log(row);
      this.$router.push(`/config_early_warning?id=${row.eventId}`);
    });
  }
  deleteEarlyWarningSetting(row) {
    return __async(this, null, function* () {
    });
  }
  closeTipDialog() {
    this.tipDialogVisible = false;
    this.errorPermissionName = "";
  }
};
__decorateClass([
  Debounce(400)
], EarlyWarningSettings.prototype, "changeEarlyWarningSettingStatus", 1);
__decorateClass([
  Debounce(400)
], EarlyWarningSettings.prototype, "searchByName", 1);
EarlyWarningSettings = __decorateClass([
  Component({
    components: {
      UiGrid,
      QuestionSlot
    }
  })
], EarlyWarningSettings);
export {
  EarlyWarningSettings as default
};
